<div class="card">
	<div class="card-header bg-transparent border-0 pt-3 pt-md-4 px-3 px-md-4 pb-0">
		<h5 class="mb-0 fw-semibold">{{ title() }}</h5>
	</div>

	<div class="card-body px-3 px-md-4 pt-2 pt-md-3 pb-2">
		@if (isLoading()) {
			<div class="placeholder-glow">
				@for (row of skeletonRows; track $index) {
					<div class="d-flex align-items-center py-2 border-bottom">
						<div class="flex-grow-1">
							<span class="placeholder col-6 placeholder-sm d-block mb-1"></span>
							<span class="placeholder col-4 placeholder-xs"></span>
						</div>
						<span class="placeholder col-2 placeholder-sm"></span>
					</div>
				}
			</div>
		} @else if (items().length === 0) {
			<div class="text-muted text-center py-4">
				<fa-duotone-icon icon="inbox" size="2x" class="mb-2 d-block" secondaryOpacity="0.3" />
				<span class="small">{{ emptyMessage() }}</span>
			</div>
		} @else {
			<div class="list-group list-group-flush">
				@for (item of items(); track item.id) {
					<div class="list-group-item border-start-0 border-end-0 px-0 py-2">
						<div class="d-flex align-items-center justify-content-between gap-2">
							<div class="min-w-0 flex-grow-1">
								<div class="fw-medium text-truncate">{{ item.primaryText }}</div>
								@if (item.secondaryText) {
									<div class="text-muted small text-truncate">{{ item.secondaryText }}</div>
								}
							</div>
							<div class="d-flex align-items-center gap-2 flex-shrink-0">
								@if (item.timestamp) {
									<span class="text-muted small d-none d-lg-inline">{{ item.timestamp | orgDate:'shortDate' }}</span>
								}
								@if (item.statusBadge) {
									<span class="d-none d-sm-inline">
										<ms-status-badge [status]="item.statusBadge" [isLoading]="false" />
									</span>
								}
								<a [routerLink]="item.routerLink" class="btn btn-sm btn-ms-secondary text-nowrap">View Profile</a>
							</div>
						</div>
					</div>
				}
			</div>
		}
	</div>
</div>
